import { Component, OnInit } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { Router } from '@angular/router';
import { PersonaArray } from 'app/shared/models/Label-Persona/label-persona';
import { LabelItemPersona } from 'app/shared/models/Persona/persona';
import { AuthenticationService } from 'app/shared/services/authentification/authentification.service';
import { DataService } from 'app/shared/services/data/data.service';
import { TitleService } from 'app/shared/services/title/title.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { UserService } from 'app/shared/services/user/user.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';

@Component({
  selector: 'app-choice-persona',
  templateUrl: './choice-persona.component.html',
  styleUrls: ['./choice-persona.component.scss']
})
export class ChoicePersonaComponent extends SubscriptionBaseComponent implements OnInit {

  color: ThemePalette = 'primary';
  personaArray: PersonaArray[];
  listLabel: LabelItemPersona[];
  listProfilUser: LabelItemPersona[];

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private userService: UserService,
    private dataService: DataService,
    private titleService: TitleService,
    private uiService: UiService
  ) {
    super();
  }

  ngOnInit(): void {
    this.initSub();
    this.getPersona();
    this.titleService.title.next('Choix profil');
  }

  redirection() {

    const array = [];

    this.personaArray.forEach(list => {
      const items = [];
      list.elements.forEach(el => {
        items.push(el.name);
      });

      const obj = {
        name: list.name,
        elements: items
      };
      array.push(obj);
    });

    let valid = 0;
    array.forEach(a => {
      if (a.elements.length < 1) {
        valid++;
      }
    });

    let nbrProfilArray = 0;
    let nbrProfilGeneric = 0;

    this.listLabel.forEach(item => {
      if (item.name === 'Persona') {
        nbrProfilGeneric += item.items.length;
      }
    });

    this.personaArray.forEach(item => {
      if (item.name === 'Persona') {
        nbrProfilArray += item.elements.length;
      }
    });

    if (valid < array.length) {

      if (nbrProfilArray >= nbrProfilGeneric) {
        this.uiService.openSnackBar('Vous ne pouvez pas selectionner tous les profils', '');
      } else {
        if (nbrProfilArray > 0) {

          this.userService.upDateMyPersona(array).subscribe(() => {
            localStorage.getItem('url') === '/profil' ?
              this.router.navigate(['/profil']) :
              this.router.navigate(['/home']);
            this.getMenu();
            this.authService.refreshToken().subscribe(() => {
              this.dataService.personaUser.next(this.authService.getDecodedToken().name);
              // this.dataService.personaSelected.next(this.authService.getDecodedToken().name);
            });
          });
        } else {
          this.uiService.openSnackBar('Vous devez selectionner au moins un profil type "Persona"', '');

        }
      }
    } else {
      this.uiService.openSnackBar('Vous devez choisir au moins un profil', '');
    }

  }


  private getMenu(): void {
    this.userService.getMenuUser().subscribe(res => {
      this.dataService.menu.next(res);
    });
  }

  private getPersona(): void {
    this.userService.getPersona().subscribe(res => {
      this.listLabel = res.genericProfiles.lists;
      this.listProfilUser = res.userProfiles.lists;

      const listLabelForCheck: LabelItemPersona[] = JSON.parse(JSON.stringify(this.listLabel));

      const i = listLabelForCheck.findIndex(obj => obj.name === ('Public' || 'Inscrit'));

      if (this.listProfilUser.length < listLabelForCheck.length) {
        listLabelForCheck.forEach(item => {
          const index = this.listProfilUser.findIndex(obj => obj.name === item.name);
          if (index === -1) {
            const list = item;
            list.items = [];
            this.listProfilUser.push(list);
          }
        });
      }
    });



  }

  private initSub(): void {
    this.subscription.add(
      this.dataService.arrayPersonas.asObservable().subscribe(pSelect => {
        this.personaArray = pSelect;
      })
    );

  }
}

